<h2>{{ 'myWorkModule.supervisorInvites' | translate }}</h2>

<div
  class="spinner-border"
  role="status"
  *ngIf="isLoading$ | async"
  attr.aria-label="{{ 'wcag.loading' | translate }}"
>
</div>

<table
  [hidden]="!(supervisorBookings$ | async).length"
  class="table table-hover"
>
  <thead class="bg-white position-lg-sticky">
    <tr>
      <th scope="col" class="d-none d-lg-table-cell">{{
        'general.date' | translate
      }}</th>
      <th scope="col" class="d-none d-lg-table-cell">
        {{ 'general.activity' | translate }} </th
      ><th scope="col" class="d-none d-lg-table-cell">
        {{ 'productModule.resource' | translate }}
      </th>
      <th scope="col" class="text-end">
        <button
          type="button"
          *ngIf="showBulkButton"
          (click)="onClickApplyActions()"
          class="btn btn-soft-primary"
          [disabled]="checkedItemsIds.size == 0"
        >
          {{ 'general.applyActions' | translate }}
        </button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="
        let supervisorBooking of supervisorBookings$ | async;
        let i = index
      "
      data-test-id="invite-row-item"
      class="d-flex flex-wrap d-lg-table-row mb-3 pb-3 pb-lg-0 mb-lg-0"
    >
      <td class="col-12 d-lg-table-cell order-1">
        {{
          (bookingEntities$ | async)[supervisorBooking.bookingId]?.startDate
            | formatDate : 'd MMM y HH:mm'
            | async
        }}
        -
        {{
          (bookingEntities$ | async)[supervisorBooking.bookingId]?.endDate
            | date : 'HH:mm'
            | roundMinutes
        }}
      </td>
      <td class="col-auto order-0 d-lg-table-cell" style="min-width: 10rem">
        <strong>{{
          (bookingEntities$ | async)[supervisorBooking.bookingId]
            ?.linkedProductId
            | getTranslation : 'product' : 'description'
            | async
        }}</strong>
      </td>
      <td class="col d-lg-table-cell" style="min-width: 10rem">
        {{
          (bookingEntities$ | async)[supervisorBooking.bookingId]?.productId
            | getTranslation : 'product' : 'description'
            | async
        }}
      </td>
      <td class="col d-lg-table-cell order-3 lg-text-nowrap">
        <ng-container
          *ngIf="
            supervisorModuleConfig.allowedStatusesForDeclineInvitation.includes(
              supervisorBooking?.status
            )
          "
        >
          <div #toggleSwitch class="btn-group">
            <button
              type="button"
              class="btn btn-soft-primary text-nowrap"
              [class.active]="
                checkedItemsIds.get(supervisorBooking.id) === 'decline'
              "
              (click)="setState(supervisorBooking.id, 'decline')"
            >
              <i class="fa fa-times me-1" aria-hidden="true" role="img"></i>
              {{ 'general.decline' | translate }}
            </button>
            <div [ngClass]="selectedState"></div>
            <button
              type="button"
              class="btn btn-soft-primary text-nowrap"
              [class.active]="
                checkedItemsIds.get(supervisorBooking.id) === 'accept'
              "
              (click)="setState(supervisorBooking.id, 'accept')"
            >
              <i class="fa fa-check me-1" aria-hidden="true" role="img"></i>
              {{ 'general.accept' | translate }}
            </button>
          </div>
        </ng-container>

        <button
          type="button"
          class="btn btn-soft-primary"
          (click)="onClickDetails(supervisorBooking)"
        >
          {{ 'general.details' | translate }}
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div
  [hidden]="(isLoading$ | async) || (supervisorBookings$ | async).length"
  class="mt-5"
  role="alert"
>
  <p class="text-center">{{ 'myWorkModule.noPendingInvites' | translate }}</p>
</div>
